import React from "react";
import jwtClient from "../JwtClient";
import Alert from "react-bootstrap/Alert";
import DateUtils from "../DateUtils";
import {DeliverTo} from "./UA/Address";
import Table from "react-bootstrap/Table";
import {Button} from "react-bootstrap";
import JSBarcode from 'jsbarcode';
import Storage from "../Storage";


function StatusHistory(props) {
    const {statusHistory} = props;
    if (statusHistory.length > 0) {
        return (
            <div>
                <h4 className="mt-3">Status history</h4>
                <Table>
                    <thead>
                    <tr>
                        <th>Status</th>
                        <th>Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    {statusHistory.map((sh, index) => {
                        return (
                            <tr key={index}>
                                <td>{sh.status}</td>
                                <td>{DateUtils.toLocalDateString(sh.date)}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </Table>
            </div>
        )
    }
    return null;
}

function Passport(props) {
    const {declaration, consignee} = props;
    let consigneePassport = null;
    if (declaration.country_of_destination === 'RU') {
        if (consignee.passport_series || consignee.passport_number) {
            consigneePassport = [
                `Passport series: ${consignee.passport_series}`,
                `Passport number: ${consignee.passport_number}`,
                `Passport issued at: ${consignee.passport_issued_at}`,
                `Passport issued by: ${consignee.passport_issued_by}`,
                `Individual taxpayer number: ${consignee.individual_taxpayer_number}`
            ].join('\n');
            return (
                <dl className="row">
                    <DT>Passport</DT>
                    <DD>
                        <pre>{consigneePassport}</pre>
                    </DD>
                </dl>
            )
        }
    }
    return null;
}


function Dimensions(props) {
    const {p} = props;
    if (p.weight_kg || p.length_cm || p.width_cm || p.height_cm) {
        return (
            <dl className="row">
                <DT>Weight, kg</DT>
                <DD>{p.weight_kg}</DD>
                <DT>Length x width x height, cm</DT>
                <DD>{p.length_cm && [p.length_cm, p.width_cm, p.height_cm].join(' x ')}</DD>
            </dl>
        )
    }
    return null;
}

function DT({children}) {
    return <dt className="col-sm-3">{children}</dt>;
}

function DD({children}) {
    return <dd className="col-sm-9">{children}</dd>;
}

export default class PackageDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            packageId: props.match.params.id,
            package: {},
            error: '',
        };
    }

    render() {
        if (Object.keys(this.state.package).length === 0) {
            return null;
        }
        if (this.state.error) {
            return <Alert variant="danger">{this.state.error}</Alert>
        }
        const p = this.state.package;
        const declaration = p.customs_declaration;
        const address = declaration.consignee_address;
        const consignee = declaration.consignee_personal_data;

        let consigneeAddress;
        if (address.deliver_to === DeliverTo.door) {
            consigneeAddress = [
                `Zip: ${address.zip}`,
                `Region: ${address.region}`,
                `City: ${address.city}`,
                `Street: ${address.street}`,
                `House: ${address.house}`,
            ];
            if (address.corpus) {
                consigneeAddress.push(`Corpus/building: ${address.corpus}`)
            }
            if (address.apartment) {
                consigneeAddress.push(`Apartment: ${address.apartment}`)
            }
            consigneeAddress = consigneeAddress.join('\n');
        } else if (address.deliver_to === DeliverTo.pickupPoint && (p.last_mile_service === 'NPI' || p.last_mile_service === 'BXB')) {
            consigneeAddress = [
                `Region: ${address.region.label}`,
                `City: ${address.city.label}`,
                `Street: ${address.street.label}`,
                `Pickup point id: ${address.street.value}`,
            ].join('\n');
        }
        let trackDD;
        if (Storage.isHumAid()) {
            trackDD = <DD><a href='#' onClick={() => this.printBarcode()}>{p.track}</a></DD>
        } else {
            trackDD = <DD>{p.track}</DD>
        }

        return (
            <div>
                <h2 className="mt-4">{`Package "${p.code}"`}</h2>
                <div className="mb-3">
                    <span className="badge badge-primary">Status: {p.status}</span>
                </div>
                <div className="mb-3">
                    <Button variant="success" href={`/package/${p.id}/update`} disabled={(_ => {
                        let disabled = true;
                        for (const s of p.status_history) {
                            if ([
                                'The package has been successfully registered and is expecting at the Hub',
                                '00-005',
                                '01-001',
                                '01-002',
                                '01-003',
                            ].includes(s.status)) {
                                disabled = false;
                            }
                        }
                        // 'created'
                        if (p.status_history.length === 0) {
                            disabled = false;
                        }
                        return disabled;
                    })()

                    }>Update</Button>
                </div>

                {p.bxb_track &&
                    <dl className="row">
                        <DT>{'Boxberry track'}</DT>
                        <DD>{p.bxb_track}</DD>
                    </dl>
                }

                <dl className="row">
                    <DT>Reference/order number</DT>
                    {trackDD}
                    <DT>Destination country</DT>
                    <DD>{declaration.country_of_destination}</DD>
                    <DT>Total price, USD</DT>
                    <DD>{p.total_price}</DD>
                </dl>
                <Dimensions p={p}/>
                <dl className="row">
                    <DT>Created</DT>
                    <DD>{DateUtils.toLocalDateString(p.created_at)}</DD>
                </dl>

                <h4 className="mt-3">Consignee</h4>
                <dl className="row">
                    <DT>First name</DT>
                    <DD>{consignee.name}</DD>
                    <DT>Middle name</DT>
                    <DD>{consignee.middlename}</DD>
                    <DT>Last name</DT>
                    <DD>{consignee.surname}</DD>
                    <DT>Phone</DT>
                    <DD>{consignee.phone}</DD>
                    <DT>Email</DT>
                    <DD>{consignee.email}</DD>
                    <DT>Address</DT>
                    <DD>
                        <pre>{consigneeAddress}</pre>
                    </DD>
                </dl>
                <Passport consignee={consignee} declaration={declaration}/>

                <h4 className="mt-3">Items</h4>
                <Table>
                    <thead>
                    <tr>
                        <th>Description</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Link</th>
                    </tr>
                    </thead>
                    <tbody>
                    {declaration.items.map((item, index) => {
                        let tdLink;
                        if (item.link) {
                            tdLink = <td><a href={item.link}>{item.link.slice(0, 30)}...</a></td>;
                        } else {
                            tdLink = <td>...</td>;
                        }
                        return (
                            <tr key={index}>
                                <td>{item.description}</td>
                                <td>{item.quantity}</td>
                                <td>{item.price}</td>
                                {tdLink}
                            </tr>
                        );
                    })}
                    </tbody>
                </Table>

                <StatusHistory statusHistory={p.status_history}/>
            </div>
        )
    }


    componentDidMount() {
        this.loadPackage('/api/v1/package/' + this.state.packageId);
    }

    loadPackage = url => {
        jwtClient.get(url)
            .then(response => {
                this.setState({package: response.data});
            })
            .catch(() => {
                this.setState({error: 'The service has responded with an error! Contact the administrators to resolve the issue!'});
            })
    }

    printBarcode = () => {
        let barcodeImg = document.createElement("img")
        JSBarcode(barcodeImg, this.state.package.track, {
            margin: 0,
        })

        let frame = document.createElement("iframe")
        frame.id = "barcodeFrame"
        frame.addEventListener('load', function () {
            frame.contentWindow.focus()
            setTimeout(() => {
                frame.contentWindow.print()
                document.body.removeChild(frame)
            }, 200)
        })
        document.body.appendChild(frame)
        frame.contentWindow.document.body.appendChild(barcodeImg)
    }
}